module.exports = __webpack_public_path__ + "static/FinalsScoreFS-3d912856c0229dc65dce7590ffa99e2a.png";